﻿"use strict"

var config = {
  xMinAvatar: {
    fit: "min",
    w: 28,
    h: 28,
  },
  minAvatar: {
    fit: "min",
    w: 35,
    h: 35,
  },
  mediumAvatar: {
    fit: "min",
    w: 156,
    h: 156,
  },
  commentAvatar: {
    fit: "min",
    w: 50,
    h: 50,
  },
  introAvatar: {
    fit: "min",
    w: 160,
    h: 160,
  },
  bigAvatar: {
    fit: "max",
    w: 500,
  },
  minMedia: {
    fit: "min",
    w: 90,
    h: 90,
  },
  previewMedia: {
    fit: "max",
    w: 501,
  },
  mediaFileInResults: {
    fit: "max",
    w: 300,
  },
  fitMax: {
    fit: "max",
  },
}

module.exports = config
